
export const PROXY_PATH="https://api.distributors.habit.io/habit-seller-portal-auto-prd"

export const SEMANTIC_VERSION='v2.23.0'

export const INTRO='no'
export const OPTIONAL_COV='no'
export const PC_NAMES='no'
export const MAIN_COLOR="false"
export const SECONDARY_COLOR="false"

export const G_API_KEY="AIzaSyDSIYbE0OuioJhTQK2s53m6OmbG93CmlhQ"
export const PARTNER_NAME="false"

export const PARTNER_IMAGE="false"



export const CDN_BASE_URL="https://cdn.habit.io"

export const WHITELABEL_CONFIG_URL="https://cdn.habit.io/insurance-products/whitelabel-bios/config-files/custom-domains"
export const VITE_API_BASE_URL="https://null"


export const API_URL="https://platform.habit.io"

export const BASENAME="habit-seller-portal-auto-prd"
export const PAYMENT="false"
export const HABIT_TAG="'''yes'''"
